import React, { useEffect } from 'react';
import type { FC } from 'react';
import {useLocation} from "react-router-dom";
import i18n from './i18nextSetup';

const LanguageInitializer: FC = () => {
    const { pathname } = useLocation();
  
    useEffect(() => {
        // パスから言語を抽出
        const pathSegments = pathname.split('/').filter(segment => segment !== '');
        const languageFromPath = pathSegments[0] || 'ja';
    
        // 有効な言語コードかチェック
        const validLanguages = ['ja', 'en'];
        const targetLanguage = validLanguages.includes(languageFromPath) ? languageFromPath : 'ja';
        
        // 現在の言語と異なる場合のみ切り替え
        if (i18n.language !== targetLanguage) {
            i18n.changeLanguage(targetLanguage);
        }
    }, [pathname]);
  
    return null; 
  };

  export default LanguageInitializer;

  

  

  
  